<template>
  <v-dialog width="350px" v-model="viewMenu">
    <v-card class="px-7 pb-2">
        <v-card-title class="mx-n7 popup-header">{{title}}</v-card-title>
        <v-layout class="ma-0" row wrap>
          <v-flex xs12>
              <v-flex xs5>
                <div class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted">
                    <div class="v-input__control">
                        <div class="v-input__slot">
                            <div class="v-text-field__slot">
                                <label for="input-x" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Anzahl Kopien</label>
                                <input v-model.lazy="copies" required="required" id="input-x" type="number" step="1" min="0" max="100">
                            </div>
                        </div>
                    </div>
                </div>
              </v-flex>

          </v-flex>
          <v-flex xs5>
            <div class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted">
                <div class="v-input__control">
                    <div class="v-input__slot">
                        <div class="v-text-field__slot">
                            <label for="input-x" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">X-Koord.</label>
                            <input v-model.lazy="x" required="required" id="input-x" type="text">
                            <div class="v-text-field__suffix">{{LängenEinheit.name}}</div>
                        </div>
                    </div>
                    <div class="v-text-field__details">
                        <div class="v-messages theme--light">
                            <div class="v-messages__wrapper"></div>
                        </div>
                    </div>
                </div>
            </div>
          </v-flex>
          <v-flex xs1>
             <v-divider vertical style="min-height: 70%"></v-divider>            
          </v-flex>

          <v-flex xs5>
            <div class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted">
                <div class="v-input__control">
                    <div class="v-input__slot">
                        <div class="v-text-field__slot">
                            <label for="input-y" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Y-Koord.</label>
                            <input v-model.lazy="y" required="required" id="input-y" type="text">
                            <div class="v-text-field__suffix">{{LängenEinheit.name}}</div>
                        </div>
                    </div>
                    <div class="v-text-field__details">
                        <div class="v-messages theme--light">
                            <div class="v-messages__wrapper"></div>
                        </div>
                    </div>
                </div>
            </div>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions>
                <v-btn small @click="apply()" color="grey lighten-2" >Übernehmen</v-btn>
                <v-btn small @click="cancel()" color="grey lighten-2" >Abbrechen</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import KnotenClass from '../../js/Knoten.js'

export default {
    data(){
        return{
            x: '0',
            y: '0',
            copies: 0,

            LängenEinheit: this.$store.state.LängenEinheiten.m,
        }
    },
    computed: {
        title() { return 'Verschieben / Kopieren'},
        viewMenu: {
            get() { return this.$store.getters.vMoveSelectionMenu },   
            set(value) { this.$store.commit('setvMoveSelectionMenu', value)} 
        },
    },
    methods: {
        apply(){
            this.$store.dispatch('moveSelection', {x: parseFloat(this.x.replace(',','.')), y: parseFloat(this.y.replace(',','.')), copies:parseInt(this.copies)})
            this.viewMenu = false

        },
        cancel(){
            this.viewMenu = false
        },
    },
}
</script>

<style>
    input[type=text] {
        text-align: right
    }
</style>